/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';

const resendTwoFactorCode = createApiAction({
  method: 'post',
  url: '/ajax/logon/twoFactorAuth/resend',
  requestBodyMapper: r => r
});

export default resendTwoFactorCode;